var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickybohoSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4d27e08b-3232-4888-b66a-1371edf5b79b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.11 79.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-77a98460-3b1b-496a-b935-afff64470e04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.14,41.15c9.29-9.4,9.29-24.69,0-34.08-4.51-4.56-10.5-7.07-16.88-7.07h0c-6.38,0-12.37,2.51-16.88,7.07l-4.32,4.37-4.32-4.37C36.23,2.51,30.23,0,23.85,0S11.48,2.51,6.97,7.07C-2.32,16.47-2.32,31.76,6.97,41.15l38.08,38.51,38.08-38.51ZM9.64,9.6c3.8-3.84,8.85-5.95,14.21-5.95s10.42,2.11,14.21,5.95l6.99,7.07,6.99-7.07c3.8-3.84,8.85-5.95,14.21-5.95s10.41,2.11,14.21,5.95c7.85,7.94,7.85,20.86,0,28.8l-35.41,35.81L9.64,38.41c-7.85-7.94-7.85-20.86,0-28.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickybohoSelection);
export default __webpack_public_path__ + "static/media/vicky boho - selection.ef63f3ece1275be92672a76b7987c2b9.svg";
export { ForwardRef as ReactComponent };